import { TOptions } from 'i18next';
import { TranslationKey } from 'src/@types/translation';

export const noAccentedCharsValidation = (
  translate: (key: TranslationKey, options?: TOptions) => string
) => ({
  noAccentedChars: /^[^\u00C0-\u017F]+$/,
  message: translate('statistics.sales.report.form.errorMsg.noAccentedChars'),
});
